module.exports = __webpack_public_path__ + "img/6C6F76_CBD1D7_B2BDC7_A6B0BF-256px.603d6582.png";